import { useMutation, useQueryClient } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

import { broadcastPropsUpdated } from '../../../../components/preview-messages';
import { markWebsiteAsChanged } from '../../../../hooks/usePlusWebsites';

import type { PageDetailsResponse, PageSeo } from './useGetPageDetails';
import { pageDetailsQueryKey } from './useGetPageDetails';

function updatePageSeo(websiteId: string, pageId: string, seo: PageSeo) {
  return axiosPrivate
    .put(`/v3/pharmacist/plus-websites/${websiteId}/pages/${pageId}/seo-settings`, seo)
    .then((r) => r.data);
}

export function useUpdatePageSeo({ websiteId, pageId }: { websiteId: string; pageId: string }) {
  const queryClient = useQueryClient();
  const queryKey = pageDetailsQueryKey(websiteId, pageId);

  return useMutation({
    mutationFn: (seo: PageSeo) => updatePageSeo(websiteId, pageId, seo),
    onSuccess: (_data, seo) => {
      const previous = queryClient.getQueryData<PageDetailsResponse>(queryKey);
      if (previous) {
        queryClient.setQueryData<PageDetailsResponse>(queryKey, { ...previous, seo });
      }
      markWebsiteAsChanged(queryClient, websiteId);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey });
      broadcastPropsUpdated();
    },
    meta: {
      successMessage: 'SEO settings updated successfully',
      errorMessage: 'Failed to update SEO settings',
    },
  });
}
